import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedUiModule } from '@firebird-web/shared-ui';
import { MaterialModule } from 'libs/shared/ui/src/lib/material.module';

@Component({
  selector: 'firebird-web-shared-dialog',
  templateUrl: './shared-dialog.component.html',
  styleUrls: ['./shared-dialog.component.scss'],
  imports: [MaterialModule, SharedUiModule],
})
export class SharedDialogComponent {
  @Input() title = '';
  @Input() subTitle = '';
  @Input() titleFontSize = '18px';
  @Input() cancelText = 'X-Cancel';
  @Input() confirmText = 'Confirm';
  @Input() showButtons = true;
  @Input() showConfirmButton = true;

  @Output() cancelled = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  public onCancel(): void {
    this.cancelled.emit();
  }

  public onConfirm(): void {
    this.confirm.emit();
  }

  public getTitle() {
    return `${this.title} ${this.subTitle}`;
  }
}
